export default __webpack_public_path__ + "static/media/reactjs.222b6b69.png";